import React, { Component } from "react";
import { View, Image, TouchableOpacity, Animated, Dimensions, ScrollView } from 'react-native'
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { loginStyles, appStyles } from "../theme/styles";
import TextView from "../components/TextView";
import Button from "../components/Button";
import { icons } from "../theme/icons";
import GradiantWraper from "../components/GradiantWraper";
import EditText from "../components/EditText";
import { loginRequest, activationRequest } from "../utils/api";
import { getUser, createUser, updateUser } from "../database/UserDal";
import Waiting from "../components/Waiting";
import { persianNumber, showMessage, getError } from "../utils/utils";
import { wp } from "../utils/responsive";
var {  height } = Dimensions.get('window');

export default class LoginScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: true,
            waiting: false,
            animation: new Animated.Value(0),
            minHeight: 150,
            maxHeight: height - 100,
            step: 0,
            secend: 60,
            fname: '',
            lname: '',
            mobile: '',
            activeCode: '',
            ncode: '',
            codemoaref: '',
            showMessage: false,
            messageContent: '',
            messageSuccess: false
        }
    }
    toggle() {
        let initialValue = this.state.expanded ? this.state.maxHeight + this.state.minHeight : this.state.minHeight,
            finalValue = this.state.expanded ? this.state.minHeight : this.state.maxHeight + this.state.minHeight;

        this.setState({
            expanded: !this.state.expanded
        });

        this.state.animation.setValue(initialValue);
        Animated.spring(
            this.state.animation,
            {
                toValue: finalValue
            }
        ).start();
    }
    getTitle(step) {
        if (step == 0) {
            return 'ورود به آد';
        } else if (step == 1) {
            return 'ثبت نام در آد';
        } else if (step == 2) {
            return 'فعال سازی اکانت';
        }
    }

    render() {
        return (

            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={loginStyles.container}>


                {this.state.expanded ? <View style={appStyles.rowBetween}>
                    <Image source={icons['ad_logo']} style={appStyles.adLogo} />
                    <TextView style={appStyles.screenTitle}>{this.getTitle(this.state.step)}</TextView>
                </View> : null}
                <View style={[appStyles.bottomView, { height: this.state.maxHeight }]}>
                    <ScrollView enableOnAndroid={true} keyboardShouldPersistTaps='handled'>

                        <View style={loginStyles.wraper}>
                            {this.state.step == 0 ? <View>
                                <GradiantWraper style={loginStyles.circleWraper}>
                                    <Image source={icons['keypass']} style={loginStyles.icon} />
                                </GradiantWraper>
                                <TextView style={[loginStyles.text, { margin: 20 }]}>شماره همراه خود را برای فعالسازی وارد نمایید</TextView>
                                <EditText
                                    hint='شماره موبایل'
                                    inputType='numeric'
                                    textStyle={{ color: 'black', width: wp(90) }}
                                    style={[appStyles.textInput, { marginTop: 20, marginBottom: 20 }]}
                                    onChangeText={(text) => {
                                        this.setState({
                                            mobile: text
                                        })
                                    }}
                                    value={this.state.mobile}
                                />
                                <Button
                                    text='ارسال کد فعالسازی'
                                    style={{ width: 150, marginTop: 40, alignSelf: 'center' }}
                                    textStyle={loginStyles.buttonText}
                                    onPress={() => {
                                        if (this.state.mobile.length == 11) {
                                            this.setState({
                                                waiting: true
                                            })
                                            loginRequest(this.state.mobile, (isConnect, response) => {
                                                this.setState({
                                                    waiting: false
                                                })
                                                if (isConnect && response.isSuccess) {
                                                    createUser(this.state.mobile, response.data.token)
                                                    this.setState({
                                                        step: 2,
                                                        secend: 60
                                                    }, () => {
                                                        this.setTimer();
                                                    })
                                                }
                                            })
                                        }

                                    }}
                                />

                            </View> : null}
                            {this.state.step === 2 ? <View>
                                <GradiantWraper style={loginStyles.circleWraper}>
                                    <Image source={icons['messagephone']} style={loginStyles.icon} />
                                </GradiantWraper>
                                <TextView style={[loginStyles.text, { margin: 20 }]}>کد فعالسازی را وارد نمایید</TextView>
                                <EditText
                                    hint='کد فعالسازی'
                                    textStyle={{ color: 'black', width: wp(90) }}
                                    inputType='numeric'
                                    style={appStyles.textInput}
                                    onChangeText={(text) => {
                                        this.setState({
                                            activeCode: text
                                        })
                                    }}
                                    value={this.state.activeCode}
                                />
                                <Button
                                    text='تایید کد فعالسازی'
                                    style={{ width: 150, marginTop: 20, alignSelf: 'center' }}
                                    textStyle={loginStyles.buttonText}
                                    onPress={() => {
                                        if (this.state.activeCode.length == 4) {
                                            this.setState({
                                                waiting: true
                                            })
                                            activationRequest(this.state.activeCode, (isConnect, response) => {
                                                this.setState({
                                                    waiting: false
                                                })
                                                if (isConnect && response.isSuccess) {
                                                    response.data['status'] = 2;
                                                    updateUser(response.data)
                                                    this.props.navigation.navigate('home')
                                                } else {
                                                    showMessage('', getError(response))
                                                }
                                            })
                                        }

                                    }}
                                />
                                <TouchableOpacity style={{ margin: 15, padding: 5 }} onPress={() => {
                                    if (this.state.secend === 0) {
                                        this.setState({
                                            waiting: true
                                        })
                                        loginRequest(this.state.mobile, (isConnect, response) => {
                                            this.setState({
                                                waiting: false,
                                            })
                                            if (isConnect && response.isSuccess) {
                                                createUser(this.state.mobile, response.data.token)
                                                this.setState({
                                                    step: 2,
                                                    secend: 60
                                                }, () => {
                                                    this.setTimer()
                                                })
                                            }
                                        })
                                    }
                                }}>
                                    {this.state.secend > 0 ? <TextView style={loginStyles.text}>اعتبار کد تا {persianNumber(this.state.secend)} ثانیه</TextView> :
                                        <TextView style={{ textAlign: 'center' }}>ارسال مجدد کد فعالسازی</TextView>}
                                </TouchableOpacity>
                            </View> : null}
                            <View />
                        </View>
                    </ScrollView>
                </View>
                <Waiting waiting={this.state.waiting} />

            </LinearGradient>)
    }

    componentWillMount() {
        var user = getUser();
        if (user != null && user.ncode != null && user.ncode.length > 0) {
            this.props.navigation.navigate('home')
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalId);
    }
    setTimer() {

        this.intervalId = setInterval(() => {
            if (this.state.secend > 0) {
                this.setState({
                    secend: this.state.secend - 1
                })
            } else {
                clearInterval(this.intervalId);
            }

        }, 1000)
    }

}
